module.exports = __webpack_public_path__ + "img/spirit_small_5.fc471696.png";